import styles from "./style.module.scss";
import { featureListOfferValueHandler } from "@lib/sharedUtils";
import TicIcon from "@components/shared/bestBuyers/icons/TicIcon";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";

export default function MainFeatures({
    mainFeatures,
}: {
    mainFeatures: {
        value: string;
        baseAttribute: {
            name: string;
            hidden: boolean;
        };
    }[];
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const devicesList = mainFeatures
        ?.find((attr) => attr?.baseAttribute?.name === "devices")
        ?.value?.split(",")
        .map((device) => (
            <span
                key={device}
                className={`${styles["device"]} ${styles[device]}`}
            ></span>
        ));
    return (
        <>
            <span className={`${styles["borderStyle"]} lg:mt-4 mt-5`}></span>
            <div className={`flex flex-col   lg:gap-1 gap-2 lg:mt-6 mt-5`}>
                {mainFeatures?.map((el, index) => (
                    <div
                        className="flex   min-w-[300px] items-center gap-2  flex-wrap"
                        key={index}
                    >
                        <TicIcon color="#000" />
                        {el?.baseAttribute?.name === "devices" &&
                        devicesList &&
                        devicesList.length ? (
                            <>
                                <div className=" font-bold lg:text-base text-xs">
                                    {translate(
                                        translations,
                                        "several_offerPage-DevicesName",
                                    )}
                                </div>
                                <span className=" lg:text-base text-xs">
                                    {devicesList}
                                </span>
                            </>
                        ) : (
                            <>
                                <div className=" font-bold lg:text-base text-xs">
                                    {el?.baseAttribute?.name}
                                </div>
                                <span className=" lg:text-base text-xs">{` - ${
                                    featureListOfferValueHandler(
                                        el.value,
                                    ) as string
                                }`}</span>
                            </>
                        )}
                    </div>
                ))}
            </div>
            <span className={`${styles["borderStyle"]} lg:mt-6 mt-5`}></span>
        </>
    );
}
